import { Container } from '../styles/menu-header';

import { ReactComponent as LogoSidebarMiniStaging } from 'assets/icons/logo-sidebar-mini-staging.svg';
import { ReactComponent as LogoSidebarMini } from 'assets/icons/logo-sidebar-mini.svg';
import { ReactComponent as LogoStaging } from 'assets/icons/logo-staging.svg';
import { ReactComponent as Logo } from 'assets/icons/logo.svg';

import { COLOR_CONFIG } from 'constants/color';
import { REACT_APP_ENV } from 'constants/environment';

export const MenuHeader = ({ delay }: { delay: boolean }) => {
  const renderIcon = (isMini = false) => {
    if (REACT_APP_ENV === 'staging') {
      if (isMini) {
        return (
          <div style={{ maxWidth: 43 }}>
            <LogoSidebarMiniStaging style={{ width: '100%', height: '100%' }} />
          </div>
        );
      }

      return (
        <div style={{ maxWidth: 200 }}>
          <LogoStaging style={{ width: '100%', height: '100%' }} />
        </div>
      );
    }

    if (isMini) {
      return <LogoSidebarMini />;
    }

    return <Logo />;
  };

  const containerStyle = {
    padding: '32px 12px 32px 24px',
    marginBottom: 0,
    height: 'auto',
    minHeight: 'auto',
    background: `${COLOR_CONFIG.doctor}`,
  };

  return <Container style={containerStyle}>{delay ? renderIcon() : renderIcon(true)}</Container>;
};
